<script lang="ts">
	import { onMount } from 'svelte';
	import type { URLState } from '../url-state';
	import { navigateTo } from '../url-state';
	import type { IdMap } from '../types';
	import { searchTransactions } from '../api';
	import Transactions from './Transactions.svelte';

	let { urlState, id2trefwoord, trefwoordIds } = $props<{
		urlState: URLState;
		id2trefwoord: IdMap<string>;
		trefwoordIds: number[];
	}>();

	let mydata = $state<{
		id2trefwoord: IdMap<string>;
		trefwoordIds: number[];
		transactions: any[];
		totaal: number;
	}>({
		id2trefwoord: {},
		trefwoordIds: [],
		transactions: [],
		totaal: 0
	});

	async function loadData() {
		if (urlState.from && urlState.until && urlState.search) {
			try {
				mydata = await searchTransactions(urlState.from, urlState.until, urlState.search);
			} catch (error) {
				console.error('Failed to search transactions:', error);
			}
		}
	}

	function handleDataChanged() {
		loadData();
	}

	onMount(() => {
		loadData();
		window.addEventListener('dataChanged', handleDataChanged);
		return () => window.removeEventListener('dataChanged', handleDataChanged);
	});

	$effect(() => {
		if (urlState.from && urlState.until && urlState.search) {
			loadData();
		}
	});
</script>

<main>
	<h1><a href="/" onclick={(e) => { e.preventDefault(); navigateTo('/', { from: urlState.from, until: urlState.until }); }}>Overzicht</a> > Zoekresultaten voor: "{urlState.search || ''}"</h1>
	<Transactions {mydata} />
</main>
